// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"447":"4743510d","4474":"4743510d","5747":"4743510d"}[chunkId] + ".chunk.css";
};